import { useConvertProject } from '@customink/project-service-react-components';

export const useCheckoutPending = () => {
  const [
    ,
    { isLoading: isConversionLoading, isSuccess: isConversionSuccessful },
  ] = useConvertProject();

  return !!(isConversionLoading || isConversionSuccessful);
};
